import * as GQL from '~/graphql/generated/client';

export const useUserTasksPaginated = (input: {
  page: number;
  pageSize: number;
  search?: string;
  projectType?: GQL.ProjectType;
  assignmentType?: GQL.AssignmentType;
  status?: GQL.AssignmentStatusType;
  filter: GQL.TaskFilter;
  isArchived?: boolean;
}) => {
  const { data, loading, error, refetch } = GQL.useUserTasksPaginatedQuery({
    variables: {
      input: {
        pagination: {
          page: input.page,
          pageSize: input.pageSize,
        },
        search: input.search,
        projectType: input.projectType,
        assignmentType: input.assignmentType,
        status: input.status,
        filter: input.filter,
        isArchived: input.isArchived,
      },
    },
    fetchPolicy: 'cache-and-network',
  });

  return {
    tasks: data?.userTasksPaginated.tasks ?? [],
    totalCount: data?.userTasksPaginated.totalCount ?? 0,
    hasNextPage: data?.userTasksPaginated.hasNextPage ?? false,
    hasPreviousPage: data?.userTasksPaginated.hasPreviousPage ?? false,
    loading,
    error,
    refetch,
  };
};
